function searchEvents(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/search`;
  return apiClient.get(route, { query });
}

function getEventById(eventId, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/event/${eventId}`;
  return apiClient.get(route);
}

function getEvents(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events`;
  return apiClient.get(route, { query });
}

function fetchEventsForBrochure(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/brochure`;
  return apiClient.get(route, { query });
}

function getMyEvents(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations`;
  return apiClient.get(route, { query });
}

function cancelRegistration(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations/cancel`;
  return apiClient.delete(route, query);
}

function updateRegistration(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations`;
  return apiClient.put(route, query);
}

function addToInterested(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations/interested`;
  return apiClient.post(route, query);
}

function getMyInterestedEvents(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations/interested`;
  return apiClient.get(route, { query });
}

function createRegistration(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations`;
  return apiClient.post(route, query);
}

function resendConfirmationEmail(query, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/registrations/confirmation`;
  return apiClient.post(route, query);
}

function getEventsSettings(apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/events/settings`;
  return apiClient.get(route);
}

export default {
  cancelRegistration,
  createRegistration,
  fetchEventsForBrochure,
  getEventById,
  getEvents,
  getMyEvents,
  getMyInterestedEvents,
  addToInterested,
  searchEvents,
  updateRegistration,
  getEventsSettings,
  resendConfirmationEmail
};
